import * as React from 'react';
import {AddIcon, SubtractIcon} from '../../../icons';
import {SpringTooling} from '../../__SharedTypes';
import {
  BUTTON_POSITIONS,
  NUMBER_INPUT_VARIANTS,
  STEP_DIRECTIONS,
} from '../_constants';
import {NumberInputValue} from '../NumberInputValue';
import {NumberInputButton} from '../NumberInputButton';
import {NumberInputStepperView} from './NumberInputStepper.style';
import {StepDirection} from '../_types';

export const NumberInputStepper = ({
  isDisabled,
  isError,
  isFocused,
  isMax,
  isMin,
  onStepClick,
  ...props
}: {
  isDisabled?: boolean;
  isError?: boolean;
  isFocused?: boolean;
  isMax?: boolean;
  isMin?: boolean;
  onStepClick: (direction: StepDirection, isSkip: boolean) => void;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> &
  SpringTooling) => {
  return (
    <NumberInputStepperView
      isDisabled={isDisabled}
      isError={isError}
      isFocused={isFocused}
      role="group"
    >
      <NumberInputButton
        Icon={SubtractIcon}
        inputVariant={NUMBER_INPUT_VARIANTS.STEPPER}
        isDisabled={isDisabled}
        isMin={isMin}
        onClick={onStepClick}
        position={BUTTON_POSITIONS.LEADING}
        stepDirection={STEP_DIRECTIONS.DOWN}
      />
      <NumberInputValue variant={NUMBER_INPUT_VARIANTS.STEPPER} {...props} />
      <NumberInputButton
        Icon={AddIcon}
        inputVariant={NUMBER_INPUT_VARIANTS.STEPPER}
        isDisabled={isDisabled}
        isMax={isMax}
        onClick={onStepClick}
        position={BUTTON_POSITIONS.TRAILING}
        stepDirection={STEP_DIRECTIONS.UP}
      />
    </NumberInputStepperView>
  );
};
